import { render, staticRenderFns } from "./LayoutFrontFooter.vue?vue&type=template&id=4a958c60&scoped=true&"
import script from "./LayoutFrontFooter.vue?vue&type=script&lang=js&"
export * from "./LayoutFrontFooter.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFrontFooter.vue?vue&type=style&index=0&id=4a958c60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a958c60",
  null
  
)

export default component.exports